import { render, staticRenderFns } from "./task-toast.vue?vue&type=template&id=67632bf5&scoped=true&"
import script from "./task-toast.vue?vue&type=script&lang=js&"
export * from "./task-toast.vue?vue&type=script&lang=js&"
import style0 from "./task-toast.vue?vue&type=style&index=0&id=67632bf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67632bf5",
  null
  
)

export default component.exports